import { render, staticRenderFns } from "./ProposalsDetails.vue?vue&type=template&id=d6f91d8c&scoped=true"
import script from "./ProposalsDetails.vue?vue&type=script&lang=js"
export * from "./ProposalsDetails.vue?vue&type=script&lang=js"
import style0 from "./ProposalsDetails.vue?vue&type=style&index=0&id=d6f91d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f91d8c",
  null
  
)

export default component.exports